import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/success-status.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = { class: "flex flex-row mt-2 gap-x-4" }
const _hoisted_2 = { class: "w-11/20" }
const _hoisted_3 = { class: "w-14/20 h-full" }
const _hoisted_4 = { class: "flex flex-row gap-x-4 items-center justify-between" }
const _hoisted_5 = { class: "flex flex-row gap-x-4 items-center" }
const _hoisted_6 = { class: "font-normal text-16px text-gray-lp-600" }
const _hoisted_7 = { class: "flex flex-row items-center" }
const _hoisted_8 = {
  key: 0,
  src: _imports_0,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_1,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_10 = { class: "flex flex-row items-center gap-2" }
const _hoisted_11 = { class: "text-gray-lp-600 italic text-12px" }
const _hoisted_12 = { class: "flex flex-row gap-x-4 items-center justify-between" }
const _hoisted_13 = { class: "flex flex-row gap-x-4 items-center" }
const _hoisted_14 = { class: "font-normal text-16px text-gray-lp-600" }
const _hoisted_15 = { class: "flex flex-row items-center" }
const _hoisted_16 = {
  key: 0,
  src: _imports_0,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_17 = {
  key: 1,
  src: _imports_1,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_18 = { class: "flex flex-row items-center gap-2" }
const _hoisted_19 = { class: "text-gray-lp-600 italic text-12px" }
const _hoisted_20 = { class: "w-full font-normal text-16px text-black-lp-100" }
const _hoisted_21 = { class: "flex flex-row gap-x-4 items-center justify-between" }
const _hoisted_22 = { class: "flex flex-row gap-x-4 items-center" }
const _hoisted_23 = { class: "font-normal text-16px text-gray-lp-600" }
const _hoisted_24 = { class: "flex flex-row items-center" }
const _hoisted_25 = {
  key: 0,
  src: _imports_0,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_26 = {
  key: 1,
  src: _imports_1,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_27 = { class: "flex flex-row items-center gap-2" }
const _hoisted_28 = { class: "text-gray-lp-600 italic text-12px" }
const _hoisted_29 = {
  key: 1,
  class: "text-16px text-black-lp-100 mb-2"
}
const _hoisted_30 = { class: "font-normal text-16px text-gray-lp-600 mb-2" }
const _hoisted_31 = { class: "w-full mb-2" }
const _hoisted_32 = { class: "font-normal text-16px text-black-lp-100" }
const _hoisted_33 = { class: "flex flex-row gap-x-4 items-center justify-between" }
const _hoisted_34 = { class: "flex flex-row gap-x-4 items-center" }
const _hoisted_35 = { class: "font-normal text-16px text-gray-lp-600" }
const _hoisted_36 = { class: "flex flex-row items-center" }
const _hoisted_37 = {
  key: 0,
  src: _imports_0,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_38 = {
  key: 1,
  src: _imports_1,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_39 = { class: "flex flex-row items-center gap-2" }
const _hoisted_40 = { class: "text-gray-lp-600 italic text-12px" }
const _hoisted_41 = { class: "w-full" }
const _hoisted_42 = { class: "font-normal text-16px text-black-lp-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chips = _resolveComponent("Chips")!
  const _component_Card = _resolveComponent("Card")!
  const _component_PreviewImage = _resolveComponent("PreviewImage")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (!!_ctx.data.daDeliveryProofPhoto && _ctx.data.daDeliveryProofPhoto.length)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: _ctx.data.daDeliveryProofPhoto[0],
              class: "rounded-md cursor-pointer",
              style: {"height":"460px","width":"400px"},
              alt: "proof-photo",
              onClick: _cache[1] || (_cache[1] = () => _ctx.actionModalPreview(true))
            }, null, 8, ["src"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Card, { class: "px-4 py-3 rounded-xl mb-2" }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("dexAssessment.proofPhoto")), 1),
                _createVNode("div", _hoisted_7, [
                  (!_ctx.data.daPhotoProofAssessment)
                    ? (_openBlock(), _createBlock("img", _hoisted_8))
                    : (_openBlock(), _createBlock("img", _hoisted_9)),
                  _createVNode("span", {
                    class: 
                  `text-14px pl-2 ${
                    !_ctx.data.daPhotoProofAssessment
                      ? 'text-green-lp-400'
                      : 'text-red-lp-1200'
                  }`
                
                  }, _toDisplayString(!_ctx.data.daPhotoProofAssessment
                    ? _ctx.$t("dexAssessment.statusValid")
                    : _ctx.$t("dexAssessment.statusInvalid")), 3)
                ])
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, _toDisplayString(_ctx.getAssessmentSourceLabel(_ctx.data.daPhotoProofAssessBy)
                  ? _ctx.$t(
                      "dexAssessment." +
                        _ctx.getAssessmentSourceLabel(_ctx.data.daPhotoProofAssessBy)
                    )
                  : ""), 1),
                (
                _ctx.shouldShowAIBadge && _ctx.isAssessedByAI(_ctx.data.daPhotoProofAssessBy)
              )
                  ? (_openBlock(), _createBlock(_component_Chips, {
                      key: 0,
                      class: "my-2",
                      color: "blue-lp-500",
                      textColor: "blue-lp-200",
                      weight: "semibold",
                      label: _ctx.$t('dexAssessment.assessByAI'),
                      rounded: ""
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Card, { class: "px-4 py-3 rounded-xl mb-2" }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("dexAssessment.reasonDex")), 1),
                _createVNode("div", _hoisted_15, [
                  (!_ctx.data.daReasonDexAssessment)
                    ? (_openBlock(), _createBlock("img", _hoisted_16))
                    : (_openBlock(), _createBlock("img", _hoisted_17)),
                  _createVNode("span", {
                    class: 
                  `text-14px pl-1 ${
                    !_ctx.data.daReasonDexAssessment
                      ? 'text-green-lp-400'
                      : 'text-red-lp-1200'
                  }`
                
                  }, _toDisplayString(!_ctx.data.daReasonDexAssessment
                    ? _ctx.$t("dexAssessment.statusValid")
                    : _ctx.$t("dexAssessment.statusInvalid")), 3)
                ])
              ]),
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.getAssessmentSourceLabel(_ctx.data.daReasonDexAssessBy)
                  ? _ctx.$t(
                      "dexAssessment." +
                        _ctx.getAssessmentSourceLabel(_ctx.data.daReasonDexAssessBy)
                    )
                  : ""), 1),
                (
                _ctx.shouldShowAIBadge && _ctx.isAssessedByAI(_ctx.data.daReasonDexAssessBy)
              )
                  ? (_openBlock(), _createBlock(_component_Chips, {
                      key: 0,
                      class: "my-2",
                      color: "blue-lp-500",
                      textColor: "blue-lp-200",
                      weight: "semibold",
                      label: "Assess by AI",
                      rounded: ""
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_20, _toDisplayString(_ctx.data.daDeliveryReasonTitle) + " - " + _toDisplayString(_ctx.data.daDeliveryReasonCode), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Card, { class: "px-4 py-3 rounded-xl mb-2" }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("dexAssessment.locationDex")), 1),
                _createVNode("div", _hoisted_24, [
                  (!_ctx.data.daLocationDexAssessment)
                    ? (_openBlock(), _createBlock("img", _hoisted_25))
                    : (_openBlock(), _createBlock("img", _hoisted_26)),
                  _createVNode("span", {
                    class: 
                  `text-14px pl-1 ${
                    !_ctx.data.daLocationDexAssessment
                      ? 'text-green-lp-400'
                      : 'text-red-lp-1200'
                  }`
                
                  }, _toDisplayString(!_ctx.data.daLocationDexAssessment
                    ? _ctx.$t("dexAssessment.statusValid")
                    : _ctx.$t("dexAssessment.statusInvalid")), 3)
                ])
              ]),
              _createVNode("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, _toDisplayString(_ctx.getAssessmentSourceLabel(_ctx.data.daLocationDexAssessBy)
                  ? _ctx.$t(
                      "dexAssessment." +
                        _ctx.getAssessmentSourceLabel(_ctx.data.daLocationDexAssessBy)
                    )
                  : ""), 1),
                (
                _ctx.shouldShowAIBadge && _ctx.isAssessedByAI(_ctx.data.daLocationDexAssessBy)
              )
                  ? (_openBlock(), _createBlock(_component_Chips, {
                      key: 0,
                      class: "my-2",
                      color: "blue-lp-500",
                      textColor: "blue-lp-200",
                      weight: "semibold",
                      label: _ctx.$t('dexAssessment.assessByAI'),
                      rounded: ""
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.data.daDeliveryAddressDex)
              ? (_openBlock(), _createBlock("span", {
                  key: 0,
                  class: "underline text-16px text-blue-600 cursor-pointer mb-2",
                  onClick: _cache[2] || (_cache[2] = 
            () =>
              _ctx.data.daDeliveryAddressDex
                ? _ctx.openLink(_ctx.data.daDeliveryGeolocationDex)
                : {}
          )
                }, _toDisplayString(_ctx.data.daDeliveryAddressDex), 1))
              : (_openBlock(), _createBlock("span", _hoisted_29, " - ")),
            _createVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("dexAssessment.recipientAddress")), 1),
            _createVNode("div", _hoisted_31, [
              _createVNode("p", _hoisted_32, _toDisplayString(_ctx.data.daSttRecipientAddress) + " " + _toDisplayString(_ctx.data.daDestinationDistrictName), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Card, { class: "px-4 py-3 rounded-xl mb-2" }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_33, [
              _createVNode("div", _hoisted_34, [
                _createVNode("p", _hoisted_35, _toDisplayString(_ctx.$t("dexAssessment.sourceDex")), 1),
                _createVNode("div", _hoisted_36, [
                  (!_ctx.data.daSourceDexAssessment)
                    ? (_openBlock(), _createBlock("img", _hoisted_37))
                    : (_openBlock(), _createBlock("img", _hoisted_38)),
                  _createVNode("span", {
                    class: 
                  `text-14px pl-1 ${
                    !_ctx.data.daSourceDexAssessment
                      ? 'text-green-lp-400'
                      : 'text-red-lp-1200'
                  }`
                
                  }, _toDisplayString(!_ctx.data.daSourceDexAssessment
                    ? _ctx.$t("dexAssessment.statusValid")
                    : _ctx.$t("dexAssessment.statusInvalid")), 3)
                ])
              ]),
              _createVNode("div", _hoisted_39, [
                _createVNode("div", _hoisted_40, _toDisplayString(_ctx.getAssessmentSourceLabel(_ctx.data.daSourceDexAssessBy)
                  ? _ctx.$t(
                      "dexAssessment." +
                        _ctx.getAssessmentSourceLabel(_ctx.data.daSourceDexAssessBy)
                    )
                  : ""), 1),
                (
                _ctx.shouldShowAIBadge && _ctx.isAssessedByAI(_ctx.data.daSourceDexAssessBy)
              )
                  ? (_openBlock(), _createBlock(_component_Chips, {
                      key: 0,
                      class: "my-2",
                      color: "blue-lp-500",
                      textColor: "blue-lp-200",
                      weight: "semibold",
                      label: "Assess by AI",
                      rounded: ""
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_41, [
              _createVNode("p", _hoisted_42, _toDisplayString(_ctx.data.daSourceDex), 1)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.showPreviewImage)
      ? (_openBlock(), _createBlock(_component_PreviewImage, {
          key: 0,
          onClose: () => _ctx.actionModalPreview(false),
          data: _ctx.data.daDeliveryProofPhoto
        }, null, 8, ["onClose", "data"]))
      : _createCommentVNode("", true)
  ], 64))
}